import * as React from 'react';

function SvgInfoRail(props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 31 32" ref={svgRef} {...props}>
      <path
        d="M20.667 23.27a.667.667 0 01-.665.665h-9.316a.667.667 0 01-.665-.665v-1.33c0-.366.298-.666.665-.666h1.996v-5.323h-1.996a.667.667 0 01-.665-.665v-1.33c0-.366.298-.666.665-.666h6.654c.367 0 .665.301.665.665v7.32H20c.367 0 .665.3.665.664v1.331zM12.682 5.971c0-.365.298-.665.665-.665h3.992c.367 0 .665.301.665.665v3.992a.667.667 0 01-.665.665h-3.992a.667.667 0 01-.665-.665V5.971zm2.66-5.378C6.862.593-.017 7.47-.017 15.953c0 8.481 6.879 15.358 15.36 15.358 8.483 0 15.36-6.877 15.36-15.359S23.826.593 15.343.593z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </svg>
  );
}

const ForwardRef = React.forwardRef(SvgInfoRail);
export default ForwardRef;
